import {colors} from "@c10h/colors";
import PlusMinus from "@components/PlusMinus";
import {Collapse} from "@mui/material";
import {useTranslation} from "ni18n";
import React, {memo, useState} from "react";
import {markdown} from "src/utils/markdown";

import {useClientSideId} from "../../../hooks/useClientSideId";
import {transparent} from "../../../utils/transparent";
import Fade from "../../animations/Fade";
import {QA} from "./Faq";

type Props = QA & {
  isPreview?: boolean;
  hideBorder?: boolean;
  hideIcon?: boolean;
  isExpandedOverride?: boolean;
  linkColorBlue?: boolean;
  onClick?: () => void;
};

const QuestionAnswer: React.FC<Props> = ({
  q,
  a,
  tags,
  isPreview,
  hideBorder,
  isExpandedOverride = false,
  onClick,
  hideIcon = false,
  linkColorBlue = false,
}) => {
  const i18n = useTranslation();
  const [isExpanded, setIsExpanded] = useState(isExpandedOverride);
  const answer = typeof a === "string" ? markdown(a, linkColorBlue) : a;
  const answerId = useClientSideId();
  return (
    <>
      <dt key={`question-${q}`} className="pt2 pb2">
        <button
          style={{"--br": 0.2}}
          className="otn brdn bg-transparent w100p df jcsb font-cm font-i-sm fw7-sm cp tal fs24 fs20-md fs16-sm gray800 ph0 pt4 focus-bsDarkBlue3 lh15 pb0"
          onClick={
            onClick ||
            (() => {
              setIsExpanded(!isExpanded);
            })
          }
          aria-expanded={isExpanded}
          aria-controls={answerId}
        >
          {q}
          <div className="pl4 mt2 mt0-sm">
            <Fade in={!hideIcon} unmountOnExit appear>
              <PlusMinus toggle={isExpanded} size={18} color={colors.gray600} />
            </Fade>
          </div>
        </button>
      </dt>
      <dd
        key={`answer-${a}`}
        className="m0 pt4"
        style={hideBorder ? {} : {borderBottom: `1px solid ${transparent(colors.gray800, 15)}`}}
      >
        <Collapse in={isPreview || isExpanded} unmountOnExit>
          <Fade in={isPreview || isExpanded}>
            <div
              className={`font-ir fs14-sm pr14 lh16 lh14-sm pb4 max-w-screen-md ${
                isPreview ? "lc3 oh tofe" : ""
              }`}
              style={{display: "-webkit-box", WebkitBoxOrient: "vertical"}}
              id={answerId}
            >
              {answer}
            </div>
          </Fade>
        </Collapse>
        {tags && tags.length > 0 && (
          <div className="df aic">
            <span className="fs12 mr4" style={{color: transparent(colors.gray800, 80)}}>
              {i18n.t("Tagged")}
            </span>
            {tags.map(tag => (
              <div
                key={q + tag}
                className="pv2 ph3 br5 fs14 font-im mr2"
                style={{
                  backgroundColor: transparent(colors.gray800, 10),
                  color: transparent(colors.gray800, 80),
                }}
              >
                {tag}
              </div>
            ))}
          </div>
        )}
      </dd>
    </>
  );
};

export default memo(QuestionAnswer);
